/**
 * Canonical registry of provider name slugs — the single source of truth used
 * everywhere a provider name is referenced (server flow actions, lib lookups,
 * `buildCredentials` calls, client store registrations, and tests) instead of
 * hardcoded string literals.
 *
 * This module is framework-agnostic: it imports no Vue, Pinia, Nitro, or Prisma,
 * so it can be consumed on either side of the client/server boundary via the
 * `#shared/` root alias.
 *
 * Slugs conform to lower_snake_case (`^[a-z][a-z0-9_]{0,29}$`). New providers are
 * added here by the change that introduces them.
 */
export const PROVIDERS = {
    AWS: 'aws',
    BETTER_STACK: 'better_stack',
    BITWARDEN: 'bitwarden',
    BITWARDEN_PASSWORD_MANAGER: 'bitwarden_password_manager',
    BURNER_MAIL: 'burner_mail',
    CLOUDFLARE: 'cloudflare',
    FIXER: 'fixer',
    FORWARD_EMAIL: 'forward_email',
    GITLAB: 'gitlab',
    GOOGLE: 'google',
    GRIDPANE: 'gridpane',
    HETZNER: 'hetzner',
    ICOUNT: 'icount',
    MAINWP: 'mainwp',
    MONIT: 'monit',
    NOTION: 'notion',
    PLOI: 'ploi',
    RUNCLOUD: 'runcloud',
    SERVERAVATAR: 'serveravatar',
    TALLYFY: 'tallyfy',
    TERMIUS: 'termius',
} as const

export type ProviderName = (typeof PROVIDERS)[keyof typeof PROVIDERS]
